<script setup lang="ts">
// Add-endorsement modal for review: pick a product endorsement or enter one manually; content uses the shared CKEditor.
import { ref, watch, nextTick } from 'vue';
import Modal from '@/components/Common/Modal.vue';

const props = defineProps<{ modelValue: boolean; endorsements: any[] }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'submit', endorsement: any): void }>();

const EDITOR_ID = 'reviewEndoEditor';
const selectedId = ref('');
const code = ref('');
const summary = ref('');

const ck = () => (window as any).CKEDITOR;
const initEditor = () => { const CK = ck(); if (!CK || !document.getElementById(EDITOR_ID)) return; CK.instances?.[EDITOR_ID]?.destroy(true); CK.replace(EDITOR_ID); };
const setEditor = (html: string) => ck()?.instances?.[EDITOR_ID]?.setData(html ?? '');
const getEditor = (): string => ck()?.instances?.[EDITOR_ID]?.getData() ?? '';
const destroyEditor = () => ck()?.instances?.[EDITOR_ID]?.destroy(true);

watch(() => props.modelValue, (open) => {
    if (open) { selectedId.value = ''; code.value = ''; summary.value = ''; nextTick(initEditor); }
    else destroyEditor();
});

const onSelect = () => {
    const e = props.endorsements.find((x: any) => x.Id === selectedId.value);
    if (e) { code.value = e.Code; summary.value = e.Summary; setEditor(e.Content); }
};
const submit = () => emit('submit', { Code: code.value, Summary: summary.value, Content: getEditor(), EndorsementOriginType: 1 });
</script>

<template>
    <Modal :modelValue="modelValue" modalName="reviewEndoModal" :tempOperatorScriptVue="true" @close="emit('close')">
        <template #header><h5 class="modal-title">Add Endorsement</h5></template>
        <template #body>
            <label class="ssq-modal-lbl">Select an endorsement</label>
            <select class="form-control mb-2" v-model="selectedId" @change="onSelect">
                <option value="">— Please select —</option>
                <option v-for="e in endorsements" :key="e.Id" :value="e.Id">{{ e.Code }} — {{ e.Summary }}</option>
            </select>
            <label class="ssq-modal-lbl">Endorsement code</label>
            <input class="form-control mb-2" v-model="code" placeholder="e.g. MWAP" />
            <label class="ssq-modal-lbl">Endorsement summary</label>
            <input class="form-control mb-2" v-model="summary" placeholder="Short label shown on the schedule" />
            <label class="ssq-modal-lbl">Endorsement content</label>
            <textarea :id="EDITOR_ID" placeholder="Full endorsement wording…"></textarea>
        </template>
        <template #footer>
            <button type="button" class="btn btn-outline-secondary" @click="emit('close')">Close</button>
            <button type="button" class="btn btn-outline-primary" :disabled="!code" @click="submit">Submit</button>
        </template>
    </Modal>
</template>
